import React, { useState } from 'react';
import CustomNavbar from '../CustomNavbar';
import HaesList from './zrHaesList';
import ZRHaesApplies from './zrHaesApplies';
import ZRSparePartsList from './zrSparePartsList';
import cfg from '../../config';

// Bewusst eine Funktion und keine Konstante: Eine Konstante auf Modulebene
// wird beim Import ausgewertet — also bevor AppContext die Werte vom Server
// uebernommen hat. Die Beschriftung truege dann dauerhaft den Rueckfallwert
// aus config.js statt des Begriffs aus tblconfig.
const TABS = () => [
  { key: 'haes',        label: `🎭 ${cfg.costumeTermPlural}` },
  { key: 'anfragen',    label: `📋 Anfragen`            },
  { key: 'ersatzteile', label: '🔧 Ersatzteile'     },
];

const ZRHaes = () => {
  const [tab, setTab] = useState('haes');

  return (
    <div style={{ minHeight: '100vh', background: '#0f1117' }}>
      <CustomNavbar />

      <div className="container-fluid px-3 px-md-4" style={{ paddingTop: '1.5rem', paddingBottom: '3rem' }}>

        <h2 style={{ color: '#e8eaf0', fontWeight: 700, marginBottom: 2 }}>{cfg.costumeTermPlural} verwalten</h2>
        <p style={{ color: '#7b82a0', fontSize: '0.85rem', marginBottom: 24 }}>
          {cfg.costumeTermPlural}, Anfragen und Ersatzteilbestellungen
        </p>

        {/* Pill-Tabs */}
        <div
          style={{
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
            marginBottom: 28,
            overflowX: 'auto',
            paddingBottom: 4,
          }}
        >
          {TABS().map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              style={{
                background:   tab === key ? '#ffc107' : 'transparent',
                color:        tab === key ? '#000'    : '#7b82a0',
                border:       `1px solid ${tab === key ? 'transparent' : '#2e3347'}`,
                borderRadius: 20,
                padding:      '7px 20px',
                cursor:       'pointer',
                fontWeight:   tab === key ? 600 : 400,
                fontSize:     '0.88rem',
                whiteSpace:   'nowrap',
                transition:   'all 0.15s ease',
                flexShrink:   0,
              }}
            >
              {label}
            </button>
          ))}
        </div>

        {tab === 'haes'        && <HaesList />}
        {tab === 'anfragen'    && <ZRHaesApplies />}
        {tab === 'ersatzteile' && <ZRSparePartsList />}

      </div>
    </div>
  );
};

export default ZRHaes;
